// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"301":"57eec410","721":"1e8f182e"}[chunkId] + ".chunk.css";
};